export interface VideoItem {
  id: string;
  title: string;
  youtubeId: string;
  description?: string;
}

export const VIDEO_DATA: Record<string, VideoItem[]> = {
  Ernährung: [
    {
      id: "ernaehrung-1",
      title: "Gesunde Ernährung",
      youtubeId: "https://youtu.be/lMu3zvq1L2A",
    },
    {
      id: "ernaehrung-2", 
      title: "Eiweiße",
      youtubeId: "https://youtu.be/2_8gQ0lnWkU",
    },
    {
      id: "ernaehrung-3",
      title: "Lipide", 
      youtubeId: "https://youtu.be/bMgtuPYiQH8",
    },
    {
      id: "ernaehrung-4",
      title: "Kohlenhydrate",
      youtubeId: "https://youtu.be/j7iqhMCl9z8",
    },
    {
      id: "ernaehrung-5",
      title: "Komplikationen",
      youtubeId: "https://youtube.com/watch?v=k_uaSKWDi3M&feature=youtu.be",
    },
    {
      id: "ernaehrung-6",
      title: "Präoperative Ernährung",
      youtubeId: "https://youtu.be/X0GavEWuoRw",
    },
    {
      id: "ernaehrung-7",
      title: "Postoperative Ernährung (1. Monat)",
      youtubeId: "https://youtu.be/h8XO9DwgW6c",
    },
    {
      id: "ernaehrung-8",
      title: "Postoperative Ernährung (Langzeit)",
      youtubeId: "https://youtu.be/Ys0kuPJvSMo",
    },
    {
      id: "ernaehrung-9",
      title: "Supplemente und Mangelerscheinungen",
      youtubeId: "youtube.com/watch?v=5SGziKlXeLI&feature=youtu.be",
    },
    {
      id: "ernaehrung-10",
      title: "Gesund und Günstig",
      youtubeId: "https://youtu.be/3DDqCmWxRTQ",
    },
    {
      id: "ernaehrung-11",
      title: "Pflanzliche Ernährung",
      youtubeId: "https://youtu.be/VncW0gNxZ20",
    },
  ],
  Verhaltenstraining: [
    {
      id: "verhaltenstraining-1",
      title: "Psychologische Folgen einer Magen-OP",
      youtubeId: "youtube.com/watch?v=foIcz9FPeCg&feature=youtu.be",
    },
    {
      id: "verhaltenstraining-2",
      title: "Essstörungen und Emotionales Essen",
      youtubeId: "https://www.youtube.com/watch?v=HJ30I4TiQ8U",
    },
    {
      id: "verhaltenstraining-3",
      title: "Depression und Tagesstruktur",
      youtubeId: "https://www.youtube.com/watch?v=S_xl9G2Qxtw",
    },
    {
      id: "verhaltenstraining-4",
      title: "Angststörung und Stigmatisierung",
      youtubeId: "https://www.youtube.com/watch?v=WgoPCmPhtwo",
    },
  ],
};
